/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profilelinkstepcode3Inputs */

const en_profilelinkstepcode3 = /** @type {(inputs: Profilelinkstepcode3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter the code shown there here.`)
};

const de_profilelinkstepcode3 = /** @type {(inputs: Profilelinkstepcode3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gib den Code, der dort steht, hier ein.`)
};

/**
* | output |
* | --- |
* | "Enter the code shown there here." |
*
* @param {Profilelinkstepcode3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const profilelinkstepcode3 = /** @type {((inputs?: Profilelinkstepcode3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profilelinkstepcode3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_profilelinkstepcode3(inputs)
	return de_profilelinkstepcode3(inputs)
});
export { profilelinkstepcode3 as "profileLinkStepCode" }